export default __webpack_public_path__ + "static/media/FTlabsHomePage.6deb52cb.mp4";